export default __webpack_public_path__ + "media/zurb/img/ecommerce/bn_search-e72a90f1eb3c8c17c7f036b5eb038c8f.png";